import React from 'react';
import { Button, Modal, Text } from '@fragments';
import useProfileForm from './hooks/useProfileForm';
import useProfileManager from './hooks/useProfileManager';
import useProfileSettings from './hooks/useProfileSettings';
import ProfileForm from './components/ProfileForm';
import ProfileList from './components/ProfileList';
import ProfileIdentity from './components/ProfileIdentity';
import './styles.scss';

// "Gerenciar perfis" (contract 2.0.0): every Instagram profile of the creator beside the
// selected one, each a separate workspace with its own settings — none is primary, all
// are edited alike. A visitor (not signed in) only drafts what it creates about.
export default function ProfileDialog({ studio: s }) {
  const manager = useProfileManager(s);
  if (!manager.enabled) return <DraftDialog studio={s} />;
  return <ProfilesDialog studio={s} manager={manager} />;
}

function DraftDialog({ studio: s }) {
  const { t } = s;
  const form = useProfileForm(s);
  return <Modal open closeLabel={t('close')} onClose={() => s.setModal(null)} title={t('profileTitle')} subtitle={t('profileSubtitle')} size="md" className="studio-dialog"
    footer={<Button disabled={!form.interests.trim()} onClick={form.submit}>{t('continue')}</Button>}>
    <ProfileForm studio={s} form={form} withHandle />
  </Modal>;
}

function ProfilesDialog({ studio: s, manager }) {
  const { t } = s;
  const { selected } = manager;
  const form = useProfileSettings(s, selected);
  const footer = <div className="studio-profiles__footer">
    {manager.inUse
      ? <Text.caption contrast={6}>{t('profileInUse')}</Text.caption>
      : <Button variant="text" color="overlay" preventLoading onClick={manager.use}>{t('profileUse')}</Button>}
    <Button disabled={!form.ready} onClick={form.submit}>{t('save')}</Button>
  </div>;
  return <Modal open closeLabel={t('close')} onClose={() => s.setModal(null)} title={t('profilesTitle')} subtitle={t('profilesSubtitle')} size="lg" className="studio-dialog studio-profiles-dialog" footer={footer}>
    <div className="studio-profiles">
      <ProfileList studio={s} manager={manager} />
      <section key={manager.selectedKey} id={manager.paneId} role="tabpanel" aria-labelledby={manager.tabId(selected)} className="studio-profiles__pane">
        <ProfileIdentity studio={s} profile={selected} />
        <ProfileForm studio={s} form={form} withMemory showMemories={manager.inUse && form.memory && !!s.features.memory} />
      </section>
    </div>
  </Modal>;
}
